<template>
  <div>
    <div class="downloads downloads--mb">
      <div :class="{'downloads__item--loading': photos_loading}" class="downloads__item">
        <div class="downloads__left">
          <img alt="Download" src="@/assets/img/downloads-zip.svg">
          <div class="downloads__info">
            <button class="downloads__name" @click="onDownloadDocs">Client’s documents</button>
          </div>
        </div>
      </div>
    </div>
    <template v-if="[table_declaration.items].length > 0">
      <h3 class="title title--mb15">Summary</h3>
      <v-client-table
        :columns="table_declaration.columns"
        :data="[table_declaration.items]"
        :options="table_declaration.options"
        class="table-default table-default--maxw"
      >
        <template #passport="{ row }">
          <button
            :class="{'table-default__copy--disabled': !row.group_name}"
            class="table-default__copy"
            @click="onCopyToClipboard(row.group_name)"
          >
            {{ row.group_name }}
          </button>
        </template>
        <template #primary_guide="{ row }">
          <button
            :class="{'table-default__copy--disabled': !row.primary_guide_full_name}"
            class="table-default__copy"
            @click="onCopyToClipboard(row.primary_guide_full_name)"
          >
            {{ row.primary_guide_full_name || '-' }}
          </button>
        </template>
        <template #phone_number="{ row }">
          <button
            :class="{'table-default__copy--disabled': !row.primary_guide_phone_number}"
            class="table-default__copy"
            @click="onCopyToClipboard(row.primary_guide_phone_number)"
          >
            {{ row.primary_guide_phone_number || '-' }}
          </button>
        </template>
        <template #license_code="{ row }">
          <button
            :class="{'table-default__copy--disabled': !row.license_code}"
            class="table-default__copy"
            @click="onCopyToClipboard(row.license_code)"
          >
            {{ row.license_code || '-' }}
          </button>
        </template>
      </v-client-table>
    </template>
    <template v-if="table_crew.items.length > 0">
      <h3 class="title title--mb15 title--mt30">Crew</h3>
      <v-client-table
        :columns="table_crew.columns"
        :data="table_crew.items"
        :options="table_crew.options"
        class="table-default"
      >
        <template #full_name="{ row }">
          <button
            :class="{'table-default__copy--disabled': !row.full_name}"
            class="table-default__copy"
            @click="onCopyToClipboard(row.full_name)"
          >
            {{ row.full_name || '-' }}
          </button>
        </template>
        <template #license="{ row }">
          <button
            :class="{'table-default__copy--disabled': !row.guide_license}"
            class="table-default__copy"
            @click="onCopyToClipboard(row.guide_license)"
          >
            {{ row.guide_license || '-' }}
          </button>
        </template>
        <template #license_code="{ row }">
          <button
            :class="{'table-default__copy--disabled': !row.guide_license_code}"
            class="table-default__copy"
            @click="onCopyToClipboard(row.guide_license_code)"
          >
            {{ row.guide_license_code || '-' }}
          </button>
        </template>
        <template #expiration_date="{ row }">
          <button
            :class="{'table-default__copy--disabled': !row.guide_license_expiration_date}"
            class="table-default__copy"
            @click="onCopyToClipboard(dateFormat(row.guide_license_expiration_date))"
          >
            {{ row.guide_license_expiration_date ? dateFormat(row.guide_license_expiration_date) : '-' }}
          </button>
        </template>
        <template #driver_confirmed="{ row }">
          <span
            :style="{ 'backgroundColor': row.driver_confirmed ? '#77b017' : '#e85c20' }"
            class="status-tag"
          >
            {{ row.driver_confirmed ? 'Yes' : 'No' }}
          </span>
        </template>
        <template #car_plate_number="{ row }">
          <button
            :class="{'table-default__copy--disabled': !row.car_plate_number}"
            class="table-default__copy"
            @click="onCopyToClipboard(row.car_plate_number)"
          >
            {{ row.car_plate_number }}
          </button>
        </template>
        <template #rental_company="{ row }">
          <button
            :class="{'table-default__copy--disabled': !row.rental_company_name}"
            class="table-default__copy"
            @click="onCopyToClipboard(row.rental_company_name)"
          >
            {{ row.rental_company_name || 'Altezza' }}
          </button>
        </template>
        <template #driver_license="{ row }">
          <button
            :class="{'table-default__copy--disabled': !row.driver_license}"
            class="table-default__copy"
            @click="onCopyToClipboard(row.driver_license)"
          >
            {{ row.driver_license || '-' }}
          </button>
        </template>
        <template #driver_license_expiry="{ row }">
          <button
            :class="{'table-default__copy--disabled': !row.driver_license_expiration_date}"
            class="table-default__copy"
            @click="onCopyToClipboard(dateFormat(row.driver_license_expiration_date))"
          >
            {{ row.driver_license_expiration_date ? dateFormat(row.driver_license_expiration_date) : '-' }}
          </button>
        </template>
      </v-client-table>
    </template>
    <AppPageContainer middle>
      <template v-if="table_cars.items.length > 0">
        <h3 class="title title--mb15 title--mt30">Cars</h3>
        <v-client-table
          :columns="table_cars.columns"
          :data="table_cars.items"
          :options="table_cars.options"
          class="table-default table-default--maxw"
        >
          <template #car_plate_number="{ row }">
            <button
              :class="{'table-default__copy--disabled': !row.car_plate_number}"
              class="table-default__copy"
              @click="onCopyToClipboard(row.car_plate_number)"
            >
              {{ row.car_plate_number || '-' }}
            </button>
          </template>
          <template #rental_company="{ row }">
            <button
              :class="{'table-default__copy--disabled': !row.rental_company_name}"
              class="table-default__copy"
              @click="onCopyToClipboard(row.rental_company_name)"
            >
              {{ row.rental_company_name || '-' }}
            </button>
          </template>
          <template #confirmed="{ row }">
          <span
            :style="{ 'backgroundColor': row.car_confirmed ? '#77b017' : '#e85c20' }"
            class="status-tag"
          >
            {{ row.car_confirmed ? 'Yes' : 'No' }}
          </span>
          </template>
        </v-client-table>
      </template>
      <template v-if="table_residence.items.length > 0">
        <h3 class="title title--mb15 title--mt30">Residence</h3>
        <v-client-table
          :columns="table_residence.columns"
          :data="table_residence.items"
          :options="table_residence.options"
          class="table-default table-default--maxw"
        >
          <template #residence="{ row }">
            <button
              :class="{'table-default__copy--disabled': !row.residence}"
              class="table-default__copy"
              @click="onCopyToClipboard(row.residence)"
            >
              {{ row.residence || '-' }}
            </button>
          </template>
          <template #count="{ row }">
            <button
              :class="{'table-default__copy--disabled': !row.count}"
              class="table-default__copy"
              @click="onCopyToClipboard(row.count)"
            >
              {{ row.count || '-' }}
            </button>
          </template>
        </v-client-table>
      </template>
      <template v-if="table_visitors.items.length > 0">
        <h3 class="title title--mb15 title--mt30">Visitors</h3>
        <v-client-table
          :columns="table_visitors.columns"
          :data="table_visitors.items"
          :options="table_visitors.options"
          class="table-default table-default--maxw"
        >
          <template #citizenship="{ row }">
            <button
              :class="{'table-default__copy--disabled': !row.citizenship}"
              class="table-default__copy"
              @click="onCopyToClipboard(row.citizenship)"
            >
              {{ row.citizenship || '-' }}
            </button>
          </template>
          <template #age_type="{ row }">
            <button
              :class="{'table-default__copy--disabled': !row.age_type}"
              class="table-default__copy"
              @click="onCopyToClipboard(row.age_type)"
            >
              {{ row.age_type || '-' }}
            </button>
          </template>
          <template #count="{ row }">
            <button
              :class="{'table-default__copy--disabled': !row.count}"
              class="table-default__copy"
              @click="onCopyToClipboard(row.count)"
            >
              {{ row.count || '-' }}
            </button>
          </template>
        </v-client-table>
      </template>
    </AppPageContainer>
    <template v-if="table_clients.items.length > 0">
      <h3 class="title title--mb15 title--mt30">Clients</h3>
      <v-client-table
        :columns="table_clients.columns"
        :data="table_clients.items"
        :options="table_clients.options"
        class="table-default table-default--maxw"
      >
        <template #h__full_name>
          <div class="table-default__left">Full name</div>
        </template>
        <template #count="{ row, index }">{{ index }}</template>
        <template #full_name="{ row }">
          <div class="table-default__left">
            <button
              :class="{'table-default__copy--disabled': !row.client.full_name}"
              class="table-default__copy"
              @click="onCopyToClipboard(row.client.full_name)"
            >
              {{ row.client?.full_name || '-' }}
            </button>
          </div>
        </template>
        <template #passport="{ row }">
          <button
            :class="{'table-default__copy--disabled': !row.client.passport}"
            class="table-default__copy"
            @click="onCopyToClipboard(row.client.passport)"
          >
            {{ row.client.passport || '-' }}
          </button>
        </template>
        <template #citizenship="{ row }">
          <button
            :class="{'table-default__copy--disabled': !row.client.citizenship}"
            class="table-default__copy"
            @click="onCopyToClipboard(row.client.citizenship.name)"
          >
            {{ row.client.citizenship?.name || '-' }}
          </button>
        </template>
        <template #gender="{ row }">
          <button
            :class="{'table-default__copy--disabled': !row.client.gender}"
            class="table-default__copy"
            @click="onCopyToClipboard(row.client.gender.name)"
          >
            {{ row.client.gender?.name || '-' }}
          </button>
        </template>
        <template #age="{ row }">
          <button
            :class="{'table-default__copy--disabled': !row.age}"
            class="table-default__copy"
            @click="onCopyToClipboard(row.age)"
          >
            {{ row.age ? row.age : '-' }}
          </button>
        </template>
        <template #dob="{ row }">
          <button
            :class="{'table-default__copy--disabled': !row.client.dob}"
            class="table-default__copy"
            @click="onCopyToClipboard(dateFormat(row.client.dob))"
          >
            {{ dateFormat(row.client.dob) }}
          </button>
        </template>
        <template #profile="{ row }">
          <div class="table-default__controls">
          <span
            :class="{
              'table-default__activity--active': row.passport_required,
              'table-default__activity--pin-green': row.passport_required && row.client.passport_copy,
              'table-default__activity--pin-red': row.passport_required && !row.client.passport_copy
            }"
            class="table-default__activity table-default__activity--adds table-default__activity--passport table-default__activity--no-events"
          ></span>
            <span
              :class="{
              'table-default__activity--resident': row.client.residence?.code === 'resident',
              'table-default__activity--foreigner': row.client.residence?.code === 'foreigner',
              'table-default__activity--ea': row.client.residence?.code === 'east_african',
              'table-default__activity--pin-green': row.residence_permit_required && row.client.residence_permit_copy,
              'table-default__activity--pin-red': row.residence_permit_required && !row.client.residence_permit_copy
            }"
              class="table-default__activity table-default__activity--adds table-default__activity--active table-default__activity--residence table-default__activity--no-events"
            ></span>
          </div>
        </template>
      </v-client-table>
    </template>
  </div>
</template>

<script>
import { getSafariGroupDocs, getSafariGroupPermits } from '@/http'
import { format, parse } from 'date-fns'

export default {
  name: 'SafariGroupDetailNP',
  props: {
    groupDetail: {
      type: Object
    }
  },
  data() {
    return {
      table_declaration: {
        items: [],
        columns: ['group_name', 'primary_guide', 'phone_number', 'license_code'],
        options: {
          headings: {
            'group_name': 'Group name',
            'primary_guide': 'Primary Guide',
            'phone_number': 'Phone',
            'license_code': 'License Code',
          },
          pagination: {show: false},
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_crew: {
        items: [],
        columns: ['full_name', 'license', 'license_code', 'expiration_date', 'driver_confirmed', 'car_plate_number', 'rental_company', 'driver_license', 'driver_license_expiry'],
        options: {
          headings: {
            'full_name': 'Full name',
            'license': 'License',
            'license_code': 'License Code',
            'expiration_date': 'Expiry',
            'driver_confirmed': 'Confirmed',
            'car_plate_number': 'Car',
            'rental_company': 'Company',
            'driver_license': 'Driver license',
            'driver_license_expiry': 'Driver license expiry',
          },
          pagination: {show: false},
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_cars: {
        items: [],
        columns: ['car_plate_number', 'rental_company', 'confirmed'],
        options: {
          headings: {
            'car_plate_number': 'Car',
            'rental_company': 'Company',
            'confirmed': 'Confirmed',
          },
          pagination: {show: false},
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_residence: {
        items: [],
        columns: ['residence', 'count'],
        options: {
          headings: {
            'residence': 'Residence',
            'count': 'Count',
          },
          pagination: {show: false},
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_visitors: {
        items: [],
        columns: ['citizenship', 'age_type', 'count'],
        options: {
          headings: {
            'citizenship': 'Citizenship',
            'age_type': 'Age type',
            'count': 'Count',
          },
          pagination: {show: false},
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_clients: {
        items: [],
        columns: ['count', 'full_name', 'passport', 'citizenship', 'gender', 'age', 'dob', 'profile'],
        options: {
          headings: {
            'count': '#',
            'full_name': 'Full name',
            'passport': 'Passport',
            'citizenship': 'Nationality',
            'gender': 'Sex',
            'age': 'Age',
            'dob': 'Date of birth',
            'profile': 'Profile',
          },
          pagination: {show: false},
          sortable: [],
          perPage: 300,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      photos_loading: false,
    }
  },
  created() {
    getSafariGroupPermits(this.$route.params.id)
      .then(res => {
        this.table_declaration.items = res.data.declaration
        this.table_crew.items = res.data.crew
        this.table_cars.items = res.data.cars
        this.table_residence.items = res.data.residence
        this.table_visitors.items = res.data.visitors
        this.table_clients.items = res.data.clients
      })
  },
  methods: {
    onDownloadDocs() {
      this.photos_loading = true
      getSafariGroupDocs(this.groupDetail.id)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${this.dateFormat(this.groupDetail.tour_start)} ${this.groupDetail.name} - Clients documents.zip`)
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(url)
          this.photos_loading = false
        })
    },

    onCopyToClipboard(string) {
      navigator.clipboard.writeText(string)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Copied to clipboard',
          })
        })
        .catch(() => {
          console.error('Something went wrong')
        })
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : '-'
    },
  }
}
</script>
